// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__33pBI","savePackageButton":"ClientWallet_savePackageButton__F_-yB"};